import LatestProjects from './LatestProjects'

export default LatestProjects